import styled from 'styled-components';
import SVGIcon from '../../atoms/SVGIcon';

export const StyledPrefixIcon = styled(SVGIcon)`
  margin-left: 24px;
  display: block;
`;
